export const FIRST_QUESTION = "Did we hit the nail on the head?";
export const ISSUE_RESOLVED = "Has your issue been resolved?";
export const ESCALATE_QUESTION =
  "If you'd like to escalate your case, please let us know below along with any additional details that may help";
